
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matches/[matchId]",
      function () {
        return require("private-next-pages/matches/[matchId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matches/[matchId]"])
      });
    }
  